<ng-container *ngIf="!documents.length">
    <br/>
    <p class="comments-not-found">Sin comentarios</p>
</ng-container>
<ng-container *ngIf="documents.length">
    <div class="comments-container">
        <table>
            <thead>
                <tr>
                    <th class="remove-on-responsive">Comentario</th>
                    <th class="remove-on-responsive" style="text-align:right;">Fecha</th>
                </tr>
            </thead>
            <tbody>
                <tr style="height:10px;"></tr>
                <ng-container *ngFor="let document of documents">
                    <tr>
                        <td class="first-column" style="text-align:left;">
                            <h6 style="font-size: 14px; margin:2px 0;">
                                {{document.createdBy}}
                                <span class="label-tag label-tag-creation" *ngIf="isCreationFile(document.isCreation)">Solicitud</span>
                                <span class="label-tag label-tag-additional" *ngIf="!isCreationFile(document.isCreation)">Adicional</span>
                            </h6>
                            <p style="font-size: 13px;"><fa-icon class="icon text-primary" [icon]="faExclamationCircle"></fa-icon>&nbsp;<b>{{document.observation}}</b></p>
                            <p style="font-size: 12px;"><fa-icon class="icon text-secundary" [icon]="faComment"></fa-icon>&nbsp;{{document.comment}}</p>
                        </td>
                        <td class="last-column" style="text-align:right;">{{formatDate(document.created)}}</td>
                    </tr>
                    <tr style="height:10px;"></tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</ng-container>